// Map Google address components (Places API New or Geocoder) into our form's
// Street / City / Zip / Country fields. Two sources feed this parser in SP5:
// the Places API (New) `Place.fetchFields({ fields: ["addressComponents"] })`
// call after an autocomplete pick, and the unchanged `Geocoder.geocode()`
// reverse-geocoding the buyer's current GPS position. The two shapes differ
// (`longText`/`shortText` in the New API vs. `long_name`/`short_name` in the
// Geocoder), so the call site normalises to the shape below before calling
// this parser — keeping the parser free of Google Maps types.
//
// `sublocality` / `administrative_area_level_1` are fallbacks for cases
// where Google has no `locality` (e.g. small villages, country-specific
// quirks). The street is assembled German-convention (street name first,
// number second) because the checkout serves primarily DACH + EU buyers.
function parseAddressComponents(components) {
    const find = (type)=>components.find((component)=>component.types.includes(type));
    const route = find("route")?.long ?? "";
    const streetNumber = find("street_number")?.long ?? "";
    const city = find("locality")?.long ?? find("postal_town")?.long ?? find("sublocality")?.long ?? find("administrative_area_level_2")?.long ?? find("administrative_area_level_1")?.long ?? "";
    const zip = find("postal_code")?.long ?? "";
    const countryCode = find("country")?.short ?? "";
    const street = streetNumber ? `${route} ${streetNumber}`.trim() : route;
    return {
        street,
        city,
        zip,
        countryCode
    };
}
export { parseAddressComponents };
